// src/constants.js

export const BRAND_NAME = "SPEAK BOLD WITH KK";
export const BRAND_TAGLINE = "Improve Your English Speaking Confidence";
export const BRAND_SLOGAN = "Join interactive speaking clubs and boost your communication skills.";
export const COPYRIGHT_TEXT = `© ${new Date().getFullYear()} Speak Bold with KK | All rights reserved`;
export const COMING_SOON_NOTICE = "🎯 Affordable Video Call English Practice Coming Soon!";
export const BRAND_COLOR = "#028891ff";
export const ALERT_COLOR = "#f41206ff";
export const TEXT_COLOR_BLACK = "#333";
export const TEXT_COLOR_WHITE = "#ffffffff";
export const BRAND_COLOR_GRADIENT_ONE = "#046f77ff";
export const BRAND_COLOR_GRADIENT_TWO = "#3eadb5ff";

export const APP_VERSION = "v1.1.6";
export const TERMS_VERSION = "v1.0.0";

// CONTACT INFORMATION
export const WHATSAPP_NUMBER = "7470517741";
export const WHATSAPP_CHAT_URL = `https://wa.me/91${WHATSAPP_NUMBER}`;
export const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029Vb7d3xQ7oQhd646Yp736";